module.exports = __webpack_public_path__ + "static/img/coupon.e68b5671.png";